import { render } from "./WalletGuard.vue?vue&type=template&id=2c1901d9&scoped=true"
import script from "./WalletGuard.vue?vue&type=script&lang=js"
export * from "./WalletGuard.vue?vue&type=script&lang=js"

import "./WalletGuard.vue?vue&type=style&index=0&id=2c1901d9&scoped=true&lang=css"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1901d9"]])

export default __exports__